import React from 'react';
export function Footer() {
  return <footer className="bg-text-primary text-primary pt-12 lg:pt-20 pb-28 lg:pb-12" data-id="element-42">
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 lg:px-[72px]" data-id="element-43">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-12 lg:mb-16" data-id="element-44">
          {/* Col 1: Brand */}
          <div className="flex flex-col" data-id="element-45">
            <a href="#" className="block mb-4 lg:mb-6" data-id="element-46">
              <img src="https://cdn.magicpatterns.com/uploads/3W8L2kirpjPTRAsEjJh9yk/ChatGPT_Image_28_abr_2026,_13_06_05_(1).png" alt="FitConecta" className="h-10 lg:h-12 w-auto brightness-0 invert" data-id="element-47" />
            </a>
            <p className="text-primary/60 text-[14px] font-light leading-relaxed max-w-[280px]" data-id="element-48">
              Plataforma de nutrición personalizada que conecta personas con
              nutriólogos certificados en México.
            </p>
          </div>

          {/* Col 2: Plataforma */}
          <div data-id="element-49">
            <h4 className="font-sans text-[13px] font-bold tracking-wider uppercase text-primary/40 mb-4 lg:mb-6" data-id="element-50">
              Plataforma
            </h4>
            <ul className="space-y-3" data-id="element-51">
              {['Cómo funciona', 'Planes', 'Profesionales', 'FAQ'].map(link => <li key={link} data-id="element-52">
                    <a href={`#${link.toLowerCase().replace(' ', '-')}`} className="text-[14px] text-primary/80 hover:text-accent-secondary transition-colors" data-id="element-53">
                      {link}
                    </a>
                  </li>)}
            </ul>
          </div>

          {/* Col 3: Legal */}
          <div data-id="element-54">
            <h4 className="font-sans text-[13px] font-bold tracking-wider uppercase text-primary/40 mb-4 lg:mb-6" data-id="element-55">
              Legal
            </h4>
            <ul className="space-y-3" data-id="element-56">
              {['Aviso legal', 'Aviso de privacidad', 'Términos de uso'].map(link => <li key={link} data-id="element-57">
                    <a href="#" className="text-[14px] text-primary/80 hover:text-accent-secondary transition-colors" data-id="element-58">
                      {link}
                    </a>
                  </li>)}
            </ul>
          </div>

          {/* Col 4: Contacto */}
          <div data-id="element-59">
            <h4 className="font-sans text-[13px] font-bold tracking-wider uppercase text-primary/40 mb-4 lg:mb-6" data-id="element-60">
              Contacto
            </h4>
            <ul className="space-y-3" data-id="element-61">
              <li data-id="element-62">
                <a href="mailto:hola@fitconecta.mx" className="text-[14px] text-primary/80 hover:text-accent-secondary transition-colors" data-id="element-63">
                  hola@fitconecta.mx
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="text-[14px] text-primary/80 hover:text-accent-secondary transition-colors" data-id="element-65">
                  Instagram
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="text-[14px] text-primary/80 hover:text-accent-secondary transition-colors" data-id="element-67">
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Disclaimer Box */}
        <div className="bg-dark/50 border border-primary/10 rounded-2xl p-6 lg:p-8 mb-8" data-id="element-68">
          <p className="text-[14px] font-bold text-primary mb-3 flex items-center" data-id="element-69">
            <span className="mr-2" data-id="element-70">⚠️</span> Aviso importante:
          </p>
          <p className="text-[12px] text-primary/60 font-light leading-relaxed mb-4" data-id="element-71">
            FitConecta es una plataforma tecnológica que facilita el acceso a
            servicios de nutrición proporcionados por profesionales
            independientes con cédula profesional verificable en el registro de
            la SEP. FitConecta no es un servicio médico ni sustituye la consulta
            con un profesional de la salud.
          </p>
          <p className="text-[12px] text-primary/60 font-light leading-relaxed mb-4" data-id="element-72">
            Los nutriólogos que ofrecen sus servicios a través de la plataforma
            son responsables de su propia práctica profesional. Si padece alguna
            enfermedad o condición médica, consulte a su médico antes de iniciar
            cualquier plan de alimentación.
          </p>
          <p className="text-[12px] text-primary/60 font-light leading-relaxed" data-id="element-73">
            Los datos personales se tratan conforme a la Ley Federal de
            Protección de Datos Personales en Posesión de Particulares
            (LFPDPPP).
          </p>
        </div>

        {/* Copyright */}
        <div className="pt-6 border-t border-primary/10 text-center lg:text-left" data-id="element-74">
          <p className="text-[12px] text-primary/40" data-id="element-75">
            © 2026 FitConecta. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}